<template>
  <!-- 搜索栏 -->
  <el-form :inline="true" class="search-bar">
    <el-form-item>
      <el-select
          v-model="filters.selectedOrganization"
          placeholder="请选择机构"
          clearable
          style="width: 200px"
      >
        <el-option
            v-for="organization in organizations"
            :key="organization.organizationID"
            :label="organization.orgName"
            :value="organization.organizationID"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 学员姓名下拉框 -->
    <el-form-item>
      <el-select
          v-model="filters.selectedUser"
          placeholder="请选择学员"
          clearable
          style="width: 200px"
      >
        <el-option
            v-for="user in users"
            :key="user.value"
            :label="user.label"
            :value="user.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 培训计划下拉框 -->
    <el-form-item>
      <el-select
          v-model="filters.selectedPlan"
          placeholder="请选择培训计划"
          clearable
          style="width: 200px"
      >
        <el-option
            v-for="plan in plans"
            :key="plan.value"
            :label="plan.label"
            :value="plan.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 搜索按钮 -->
    <el-form-item>
      <el-button type="primary" @click="fetchExamDetails">搜索</el-button>
    </el-form-item>
    <el-form-item>
      <el-select v-model="selectedDataType" placeholder="选择展示数据" style="width: 200px;" @change="processData">
        <el-option label="学习时长" value="learnedTime"></el-option>
        <el-option label="完成率" value="planwcl"></el-option>
      </el-select>
    </el-form-item>
  </el-form>

  <div class="container">
    <!-- 切换图表类型 -->
    <el-row justify="center" style="margin-bottom: 20px;">
      <el-button type="primary" @click="showBarChart">柱状图</el-button>
      <el-button type="success" @click="showPieChart">饼状图</el-button>
    </el-row>

    <!-- 分组方式选择 -->
    <el-row justify="center" style="margin-bottom: 20px;">
      <el-select v-model="selectedGroup" placeholder="选择分组方式" style="width: 200px;" @change="processData">
        <el-option label="按机构" value="organization"></el-option>
        <el-option label="按计划" value="plan"></el-option>
      </el-select>
    </el-row>

    <!-- 图表容器 -->
    <div id="chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import axios from "@/axios";
import { ElMessage, ElDialog } from "element-plus";
export default {
  data() {
    return {
      chartType: "bar", // 图表类型
      chart: null, // 图表实例
      data: [], // 后端获取的数据
      selectedDataType: "learnedTime", // 默认展示学习时长
      selectedGroup: "organization", // 默认分组方式
      chartData: [], // 图表数据
      organizations: [], // 机构列表
      users: [], // 学员列表
      plans: [], // 培训计划列表
      filters: {
        selectedOrganization: null,
        selectedUser: null,
        selectedPlan: null,
      },
    };
  },
  mounted() {
    // 初始化 ECharts 实例
    this.chart = echarts.init(document.getElementById("chart"));
    // 获取初始数据
    this.fetchExamDetails();
    // 获取机构列表
    axios
        .get("/organization/orglist")
        .then((res) => {
          this.organizations = res.data.data;
        })
        .catch(() => {
          ElMessage.error("获取机构列表失败");
        });
  },
  methods: {
    // 处理数据并生成图表
    processData() {
      const groupedData = {};
      const groupKey = this.selectedGroup === "organization" ? "organizationName" : "planName";

      // 按选择的字段分组数据
      this.data.forEach((item) => {
        const group = item[groupKey];
        if (!groupedData[group]) groupedData[group] = { totalValue: 0, count: 0 };
        groupedData[group].totalValue += item[this.selectedDataType];
        groupedData[group].count += 1;
      });

      // 转化为图表数据格式
      this.chartData = Object.entries(groupedData).map(([key, value]) => ({
        name: key,
        value: this.selectedDataType === "planwcl" ? value.totalValue / value.count : value.totalValue,
      }));

      // 更新图表
      this.updateChart();
    },

    // 更新图表显示
    updateChart() {
      const option = {
        title: {
          text: `统计数据（${this.chartType === "bar" ? "柱状图" : "饼状图"}）`,
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: this.chartType === "bar" ? "{b}: {c}" : "{a} <br/>{b}: {c} ({d}%)",
        },
        xAxis: this.chartType === "bar"
            ? { type: "category", data: this.chartData.map((item) => item.name) }
            : null,
        yAxis: this.chartType === "bar"
            ? { type: "value" }
            : null,
        series: [
          {
            name: this.selectedDataType === "learnedTime" ? "学习时长" : "完成率",
            type: this.chartType,
            data: this.chartData,
          },
        ],
      };
      this.chart.setOption(option, true);
    },

    fetchExamDetails() {
      const params = {
        userid: this.filters.selectedUser, // 学员ID
        planid: this.filters.selectedPlan, // 培训计划ID
        organizationID: this.filters.selectedOrganization||2, // 机构ID
      };

      console.log("查询参数：", params);

      axios
          .get("/user-watch-history/learnstatus1", { params })
          .then((response) => {
            const fetchedData = response.data.data;
            this.data = fetchedData; // 更新组件的数据
            this.extractUniqueNamesAndPlans(fetchedData); // 提取下拉框选项
            this.processData(); // 处理数据并更新图表
          })
          .catch((error) => {
            console.error("获取学习详情失败：", error);
            this.$message.error("获取学习详情失败！");
          });
    }, // 提取并去重学员姓名和培训计划名称
    extractUniqueNamesAndPlans(data) {
      const uniqueNames = new Set();
      const uniquePlans = new Set();

      data.forEach((item) => {
        uniqueNames.add(item.userId);
        uniquePlans.add(item.planId);
      });

      this.users = Array.from(uniqueNames).map((userId) => {
        const user = data.find((item) => item.userId === userId);
        return { label: user.name, value: userId }; // 显示 name，传递 userId
      });

      this.plans = Array.from(uniquePlans).map((planId) => {
        const plan = data.find((item) => item.planId === planId);
        return { label: plan.planName, value: planId }; // 显示 planName，传递 planId
      });
    },

    // 切换图表类型
    showBarChart() {
      this.chartType = "bar";
      this.updateChart();
    },
    showPieChart() {
      this.chartType = "pie";
      this.updateChart();
    },
  },
};
</script>

<style scoped>
.container {
  width: 80%;
  margin: auto;
  padding: 20px;
  text-align: center;
}
</style>
